
<div class="dataTb multi-collapse collapse show">
  <div class="table-responsive">
    <table mat-table matSort [dataSource]="dataSource" (matSortChange)="ChangeSort()"
      class="table table-striped table-bordered dataTable no-footer">

      <!-- Action Column -->
      <ng-container [matColumnDef]="TableSetting.IdColumnName" *ngIf="TableSetting.ShowActionIcon">
        <th mat-header-cell *matHeaderCellDef [ngStyle]="TableSetting.HeadStyle">
          <span *ngIf="TableSetting.CanCheck==false" >Action</span>
          <mat-checkbox *ngIf="TableSetting.CanCheck"
              (change)="CheckAllItem()"
              [(ngModel)]="CheckAll"></mat-checkbox>
          <span *ngIf="TableSetting.CanCheck">all</span>
        </th>
        <td mat-cell *matCellDef="let element">
          <div style="display: flex" class="mr-2">
            <a *ngIf="TableSetting.CanUpdate" class="far fa-edit icon-dark" title="Edit"
              (click)="EditItem(element)"></a>
            <a *ngIf="TableSetting.CanDelete" class="far fa-trash-alt ml-1 icon-dark" title="Delete"
              (click)="DeleteItem(element)"></a>
            <a *ngIf="TableSetting.CanMonitor" class="fas fa-tv ml-1 icon-dark" title="Monitor"
              (click)="MonitorItem(element)"></a>
              <mat-checkbox *ngIf="TableSetting.CanCheck"
              (change)="CheckItem(element)"
              [(ngModel)]="element.checked"></mat-checkbox>
          </div>
        </td>
      </ng-container>
      <ng-container [matColumnDef]="column.columnDef" *ngFor="let column of TableSetting.CorrespondTableHeard">
        <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="TableSetting.HeadStyle" [disabled]="!TableSetting.CanSort"> {{ column.header }} </th>
        <td mat-cell [ngStyle]="getCellStyle(column, element)" *matCellDef="let element" [ngSwitch]="column.columnType" [style.text-align]="GetCellAlign(column.columnType)">
          <ng-container *ngSwitchCase="'checkbox'">
              <mat-checkbox *ngIf="element[column.columnDef].visible"
              (change)="changeCellValue(element)"
              [(ngModel)]="element[column.columnDef].selected"
              [disabled]="!element[column.columnDef].enable"
              ></mat-checkbox>
          </ng-container>
          <input [(ngModel)]="element[column.columnDef]" *ngSwitchCase="'textbox'" (change)="changeCellValue(element)">
          <a herf="#" *ngSwitchCase="'link'" (click)="LinkItem(element, column.columnDef)">{{element[column.columnDef]}}</a>
          <ng-container *ngSwitchDefault>
            {{ showCell(column, element) }}
          </ng-container>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="DisplayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: DisplayedColumns;"></tr>
    </table>
  </div>
</div>
